import { render, staticRenderFns } from "./SettingForm.vue?vue&type=template&id=0dfc7151&"
import script from "./SettingForm.vue?vue&type=script&lang=js&"
export * from "./SettingForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports